import React, { useState, useEffect, useRef } from 'react'
import { Dialog, DialogContent, DialogActions, DialogTitle, MenuItem, TextField, Button, Box, IconButton, Card, CardMedia, CardActions, Grid } from '@mui/material';
import { app, database, storage } from '../../../firebaseConfig'
import { updateDoc, collection, query, orderBy, onSnapshot, doc } from 'firebase/firestore'
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage"
import CloseIcon from '@mui/icons-material/Close';
import testImg from '../../../assets/testImg.png'
import dateFormat, { masks } from "dateformat";
function EditChu({ onClose, open, data, list }) {
    const id = data.id
    const [code, setCode] = useState(data.code_chu)
    const [nom, setNom] = useState(data.nom_chu)
    const [email, setEmail] = useState(data.email_chu)
    const [contact, setContact] = useState(data.contact_chu)
    const [contact1, setContact1] = useState(data.contact1_chu)
    const [photo, setPhoto] = useState({})
    const [logo, setLogo] = useState({})
    const [adresse, setAdresse] = useState(data.adresse_chu)
    const [description, setDescription] = useState(data.description_chu)
    const [region, setRegion] = useState(data.region_id)
    const [regions, setRegions] = useState([])
    const inputFileRef = useRef(null)
    const inputLogoRef = useRef(null)
    const [photoDisplay, setPhotoDisplay] = useState(data.photo_chu)
    const [logoDisplay, setLogoDisplay] = useState(data.logo_chu)
    const lastImage = data.photo_chu
    const lastLogo = data.logo_chu
    useEffect(() => {
        const q = query(collection(database, 'region'), orderBy('nom', 'asc'))
        onSnapshot(q, (querySnapshot) => {
            setRegions(querySnapshot.docs.map(doc => ({
                id: doc.id,
                data: doc.data()
            })))
        })
    }, [])
    const handleSubmit = async (e) => {
        e.preventDefault()
        let urlImage = lastImage
        let urlLogo = lastLogo
        let type_img ="img"
        let type_logo ="logo"
        if (photo.name) {
            urlImage = await uploadImage(photo,type_img)
        }
        const chuDocRef = doc(database, 'chu', id)
        if (logo.name) {
            urlLogo = await uploadImage(logo,type_logo)
        }
        try {
            await updateDoc(chuDocRef, {
                code_chu: code,
                nom_chu: nom,
                email_chu: email,
                contact_chu: contact,
                contact1_chu: contact1,
                description_chu: description,
                region_id: region,
                photo_chu: urlImage,
                logo_chu: urlLogo,
                adresse_chu:adresse
            })
            onClose()
        } catch (err) {
            alert(err)
        }
    }
    const clickImage = (e) => {
        e.preventDefault()
        if (inputFileRef.current) {
            inputFileRef.current.click();
        }
    }
    const clickLogo = (e) => {
        e.preventDefault()
        if (inputLogoRef.current) {
            inputLogoRef.current.click();
        }
    }
    const changeImage = (e) => {
        const file = e.target.files[0]
        setPhoto(file)
        const reader = new FileReader();

        reader.onload = () => {
            setPhotoDisplay(reader.result);
        };

        reader.readAsDataURL(file);
    }
    const changeLogo = (e) => {
        const file = e.target.files[0]
        setLogo(file)
        const reader = new FileReader();
        reader.onload = () => {
            setLogoDisplay(reader.result);
        };
        reader.readAsDataURL(file);
    }
    const uploadImage = (fileParm,type) => {
        const nom_img = "chu_"+type+"_"+dateFormat(new Date(),'yyyymmddHHMMss')
        return new Promise((resolve, reject) => {
            const storageRef = ref(storage, nom_img)
            const uploadTask = uploadBytesResumable(storageRef, fileParm)
            uploadTask.on('state_changed', (snapshot) => {
                const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                console.log('Upload is ' + progress + '% done');
            },
                (error) => {
                    console.log(error.message)
                    reject(error);
                },
                () => {
                    getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                        console.log('File available at', downloadURL);
                        resolve(downloadURL);
                    }).catch((error) => {
                        console.log(error.message);
                        reject(error);
                    });
                }
            )
        })

    }

    return (
        <div>
            <Dialog
                open={open}
                onClose={onClose}
            >
                <DialogTitle>Modification des informations d'une CHU</DialogTitle>
                <IconButton aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}>
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    <Box component="form"
                        noValidate
                        autoComplete="off">
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <Card sx={{ mx: 2, maxWidth: 200 }}>
                                    <CardMedia
                                        style={{ objectFit: 'contain', marginTop: 1, height: 80 }}
                                        image={photoDisplay ? photoDisplay : testImg}
                                        title="green iguana"
                                    />
                                    <CardActions style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                        <Button size="small" onClick={clickImage}>Choisir une photo</Button>
                                    </CardActions>
                                </Card>
                            </Grid>
                            <Grid item xs={6}>
                                <Card sx={{ mx: 2, maxWidth: 200 }}>
                                    <CardMedia
                                        style={{ objectFit: 'contain', marginTop: 1, height: 80 }}
                                        image={logoDisplay ? logoDisplay : testImg}
                                        title="green iguana"
                                    />
                                    <CardActions style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                        <Button size="small" onClick={clickLogo}>Choisir une photo</Button>
                                    </CardActions>
                                </Card>
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    required
                                    size='small'
                                    margin="dense"
                                    id="code_chu"
                                    name="code_chu"
                                    label="Code du CHU"
                                    fullWidth
                                    onChange={(e) => {
                                        setCode(e.target.value)
                                    }}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    value={code}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    required
                                    size='small'
                                    margin="dense"
                                    id="nom_chu"
                                    name="nom_chu"
                                    label="Nom du CHU"
                                    fullWidth
                                    onChange={(e) => {
                                        setNom(e.target.value)
                                    }}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    value={nom}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    required
                                    size='small'
                                    margin="dense"
                                    id="email"
                                    name="email"
                                    label="Email"
                                    fullWidth
                                    onChange={(e) => {
                                        setEmail(e.target.value)
                                    }}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    value={email}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    required
                                    size='small'
                                    margin="dense"
                                    id="contact"
                                    name="contact"
                                    label="Contact"
                                    fullWidth
                                    onChange={(e) => {
                                        setContact(e.target.value)
                                    }}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    value={contact}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    required
                                    size='small'
                                    margin="dense"
                                    id="contact1"
                                    name="contact1"
                                    label="Contact1"
                                    fullWidth
                                    onChange={(e) => {
                                        setContact1(e.target.value)
                                    }}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    value={contact1}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    required
                                    size='small'
                                    margin="adresse"
                                    id="adresse"
                                    name="adresse"
                                    label="Adresse"
                                    fullWidth
                                    onChange={(e) => {
                                        setAdresse(e.target.value)
                                    }}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    value={adresse}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    required
                                    size='small'
                                    id="outlined-select-currency"
                                    select
                                    label="Province"
                                    defaultValue={region}
                                    fullWidth
                                    onChange={(e) => {
                                        setRegion(e.target.value)
                                    }}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                >
                                    <MenuItem key=" " value="">
                                        Veuillez selectionner un région
                                    </MenuItem>
                                    {regions.map((region) => (
                                        <MenuItem key={region.id} value={region.id}>
                                            {region.data.nom}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    required
                                    size='small'
                                    margin="dense"
                                    id="description"
                                    name="description"
                                    label="Description"
                                    fullWidth
                                    onChange={(e) => {
                                        setDescription(e.target.value)
                                    }}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    value={description}
                                />
                            </Grid>
                        </Grid>
                        <TextField
                            required
                            size='small'
                            margin="dense"
                            id="Image"
                            name="image"
                            label="Image"
                            fullWidth
                            onChange={changeImage}
                            type='file'
                            InputLabelProps={{
                                shrink: true,
                            }}
                            style={{ display: 'none' }}
                            inputRef={inputFileRef}
                        />
                        <TextField
                            required
                            size='small'
                            margin="dense"
                            id="Image"
                            name="image"
                            label="Image"
                            fullWidth
                            onChange={changeLogo}
                            type='file'
                            InputLabelProps={{
                                shrink: true,
                            }}
                            style={{ display: 'none' }}
                            inputRef={inputLogoRef}
                        />
                    </Box>

                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose}>Annuler</Button>
                    <Button variant='contained' color='success' onClick={handleSubmit}  >Enregistrer</Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default EditChu